import { useApi, QueryKeys } from "@akina/infra";
import { useQuery } from "@tanstack/react-query";
import { useLocaleStore } from "./useLocaleStore";

const STALE_TIME = 1000 * 60; // Consider data fresh for 1 minute
const REFRESH_INTERVAL = 1000 * 60 * 5; // Force a refresh of the data every 5 minutes
const GC_TIME = Infinity; // Keep data in memory until the app is closed

export const useFetchLocaleCopy = (slugs: string[]) => {
  const { api } = useApi();
  const { locale } = useLocaleStore();

  return useQuery({
    // Sort the slugs array to avoid false re-renders
    queryKey: [QueryKeys.fetchLocaleCopy, locale, JSON.stringify([...slugs].sort((a, b) => a.localeCompare(b)))],
    queryFn: async ({ signal }: { signal: AbortSignal }) => {
      return api.localeCopy.getCmsCopy(slugs, signal);
    },

    staleTime: STALE_TIME,
    refetchInterval: REFRESH_INTERVAL,
    refetchIntervalInBackground: true,
    gcTime: GC_TIME,

    // Does not cost anything to refetch if the ETag did not change
    refetchOnWindowFocus: true,
    enabled: !!locale && slugs.length > 0,
  });
};
